type Props = {
  total: number;
  pageSize: number;
  page: number;
  onChange: (page: number) => void;
};

export default function Pagination({ total, pageSize, page, onChange }: Props) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav aria-label="分页" className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="h-9 px-3 rounded-md border border-background-200 text-sm text-foreground-700 inline-flex items-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-arrow-left-s-line w-4 h-4 flex items-center justify-center"></i>
        上一页
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          aria-current={p === page ? 'page' : undefined}
          onClick={() => onChange(p)}
          className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
            p === page
              ? 'bg-primary-500 text-background-50'
              : 'border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="h-9 px-3 rounded-md border border-background-200 text-sm text-foreground-700 inline-flex items-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
      >
        下一页
        <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
      </button>
    </nav>
  );
}